import {
  getActivationStep,
  getCoachSubsteps,
  getStepSubsteps,
} from "../activation/activationPath";

/** @deprecated use getTrainingLessonSubsteps — returns ids only */
export const TRAINING_LESSON_SUBS = Object.fromEntries(
  ["direction", "venue", "group", "schedule", "plan", "client", "issue", "attendance", "parents", "overview", "chat", "team", "finance", "settings"]
    .map((id) => {
      const step = getActivationStep(id);
      return step
        ? [id, getStepSubsteps(step, { isMobile: false }).map((s) => s.id)]
        : null;
    })
    .filter(Boolean),
);

export function getTrainingNavOpts(isMobile, track = "quick") {
  return { isMobile, skipNav: track !== "quick" };
}

export function getTrainingLessonSubsteps(
  lessonId,
  { isMobile = false, skipNav = true } = {},
) {
  const step = getActivationStep(lessonId);
  if (!step) return [];
  return getCoachSubsteps(step, {
    isMobile,
    skipNav: skipNav || Boolean(step.trainingOnly),
  });
}

/** Backward-compatible: list of substep ids */
export function getTrainingSubsteps(lessonId, navOpts) {
  return getTrainingLessonSubsteps(lessonId, navOpts).map((s) => s.id);
}

export function isTourVisitLesson(lessonId) {
  const step = getActivationStep(lessonId);
  return Boolean(step?.trainingOnly || step?.predicate?.startsWith("hasVisited"));
}
